<template>
  <div class="footer">
    <div class="page-width">
      <div class="rightcopy">
        <p>
          <span>Copyright © 2019 jxjypt.cn All Rights Reserved | </span>
          <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备17043231号</a>
        </p>
        <p>
          <span>出版物许可证：新出发京零字第海180088号 | 电信业务经营许可证编号：京B2-20190114 | </span>
          <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802031480" target="_blank">
            京公网安备11010802031480号
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'HomeHeader',
  computed: {
    ...mapState(['city'])
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  .footer{
    height:150px;
    background:#333333;
    color:#f2f2f2;
    text-align:center;
    line-height:30px;
    .rightcopy{
      padding-top:40px;
    }
  }
  .rightcopy, .rightcopy a {
    margin-top: 30px;
    line-height: 28px;
    font-size: 0.9rem;
    font-weight: 400;
    color: #9AA1AB;
  }
  .rightcopy a:hover {
    color: #2979FF;
  }
</style>



// WEBPACK FOOTER //
// src/common/components/Foot.vue